<template>
    <div style="display:flex; flex-direction: column; " :style="{ overflow: selectedData && selectedData.id ? null : 'hidden' }">
        <div style="position: relative;">
            <template>
                <div style="display: flex; position: relative;">
                    <img style="width: 20px; position: absolute; top: 50%; margin-left: 12px; transform: translateY(-50%);" :src="require('@/assets/img/search_new_gray.png')" alt="">
                    <input class="search_region" ref="searchWordInput" style="height:44px; font-size:16px; width: 100%; border:none; background-color: #fff; border-radius: 5px; outline: none; padding: 12px 15px; padding-left: 42px;" placeholder="장소 이름 검색" type="text" @input="setSearchWord($event)" @keyup="enter($event)">
                    <!-- <div style="height:50px;display:grid;place-items: center; width:70px;background-color: var(--color-main); color:white; border-radius:5px; margin-left:5px;" @click="searchBefore">검색</div> -->
                </div>
                <div v-if="!isResultExist || (!selectedData && !selectedData.id)" style="color: #606060; font-weight: 500; font-size: 12px; margin-top: 8px; margin-left: 10px;">예시 : 서울월드컵경기장</div>
            </template>

            <template v-if="selectedData && selectedData.id">
                <div style="margin-top: 10px; border-radius: 5px;  padding: 10px; background-color: #fff;width:100%; position: relative; ">
                    <div @click="unselect" style="position: absolute; top: 50%; right: 5px; width: 30px; height: 30px; transform: translateY(-50%); display: flex; justify-content: center; align-items: center;">
                        <img style="width: 10px;" :src="require('@/assets/img/search_x_btn.png')" alt="">
                    </div>
                    <div style="display:flex;align-items:center;">
                        <!-- <img :src="require('@/assets/img/region_new_gray.png')" style="height:18px;margin-right:7px;"> -->
                        <div style="color:var(--color-main)">{{ selectedData.name }}</div>
                    </div>
                    <div style="font-size: 12px; font-weight: 500; color: #606060; margin-top: 5px;">{{ selectedData.address }}</div>
                </div>
            </template>
        </div>

        <template v-if="selectedData && selectedData.id">
            <div style="flex:1;">
                <div id="branch_map" style="width:100%; height:240px;outline:none;"></div>
            </div>
        </template>

        <template v-else>
            <div v-if="isResultExist" style="height: 200px; background-color: #fff; border-radius: 5px; padding-left: 10px; margin-top: 10px;">
                <InfinityScroll :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage" style="height:100%;">
                    <div v-for="each, i in places" :key="i" style=" padding:10px 0px;" @click="select(each)">
                        <div style="display:flex; align-items: center; margin-bottom: 6px;">
                            <!-- <img :src="require('@/assets/img/region_new_gray.png')" style="height:18px; margin-right:7px;"> -->
                            <div style="flex:1; color:#606060; " v-html="each.display_str"></div>
                        </div>
                        <div style="color: #bbbbbb; font-size:14px;">{{ each.address }}</div>
                    </div>
                </InfinityScroll>
            </div>
        </template>
    </div>
</template>

<script>
import InfinityScroll from "./InfinityScroll";
import NaverMap from "../../modules/NaverMap";
import _ from 'lodash';
export default {
    name: "NewPlaceSearchSelector",
    components: { InfinityScroll },
    props: {
        detectSelect: {
            type: Function,
            default: () => { }
        },
        isDuplicate: {
            type: Boolean,
            default: false,
        },
        placeInfo: {
            type: Object,
            default: () => { }
        },
        resetInfo: {
            type: Function,
            default: () => { }
        },
        isModify: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isEnableNextPageHandle: true,
            places: [],
            searchWord: '',
            page: 1,
            isResultExist: false,
            selectedData: {
                // code : '1234',
                // sido : '부산광역시',
                // sigungu : '연제구'
            }
        }
    },
    mounted() {

    },
    created() {
        if (this.isDuplicate) this.select(this.placeInfo)

        if (this.isModify) this.select(this.placeInfo)

        this.debounceAPISearch = _.debounce(() => {
            this.searchBefore();
        }, 600);
    },
    methods: {
        setSearchWord(e) {
            this.searchWord = e.target.value
        },
        enter() {
            this.debounceAPISearch();
        },
        searchBefore() {
            this.page = 1;
            this.places = [];
            this.search();
        },
        debounceAPISearch: () => { },
        async search() {
            this.isEnableNextPageHandle = false;

            const parameters = {};
            parameters.searchWord = this.searchWord;
            parameters.page = this.page;
            const res = await this.$Axios.get('/api/place', { params: parameters });

            if (res.data.code !== -1) {
                const places = res.data.places;
                for (const each of places) {
                    each.display_str = (each.name).replace(this.searchWord, "<span style='color:var(--color-main)'>" + this.searchWord + "</span>")
                }

                if (places.length > 0) {
                    this.isResultExist = true
                    // this.isEnableNextPageHandle = true;
                    // this.places = [...this.places, ...places];
                    this.places = places
                } else if (places.length === 0) {
                    this.isResultExist = false
                }
            } else {
                this.isResultExist = false
                console.log(res.data.msg)
            }


        },
        handleNextPage() { },
        select(data) {
            this.places = [];
            this.selectedData = data;
            this.detectSelect(data);

            this.$nextTick(() => {
                this.naverMap = new NaverMap();
                const options = {
                    pinchZoom: false,
                    scrollWheel: false,
                    draggable: false,
                };
                this.naverMap.initMap('branch_map', data.gps_latitude, data.gps_longitude, options);
                this.naverMap.setCenterMarker(data.gps_latitude, data.gps_longitude);
            })
        },
        unselect() {
            this.selectedData = {};
            this.searchWord = '';
            this.isResultExist = false
            this.$nextTick(() => {
                this.$refs.searchWordInput.focus();
                this.$refs.searchWordInput.value = ''
            })
            this.resetInfo()
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.search_region::placeholder {
    color: #bbbbbb;
    font-size: 14px;
    font-weight: 500;
}
</style>